package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.model.MemberRole
import fr.manyverse.app.domain.repository.GameTableRepository

class GetAllUserActiveTablesUseCase(
    private val gameTableRepository: GameTableRepository
) {
    suspend operator fun invoke(userId: String): Result<List<Pair<GameTable, MemberRole>>> {
        return gameTableRepository.getAllUserActiveTables(userId)
    }
}
